import { Skeleton } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { globalConst, parseSubjectName, truncateText, useSubjectsData } from 'modules/global';

const SubjectsList = () => {
  const t = useTranslations();
  const { query } = useRouter();
  const { subjects, isLoading: subjectsLoading } = useSubjectsData();

  return (
    <div className="rounded-2xl bg-white p-4 shadow-md sm:col-span-1">
      <p className="text-sm text-gray-400">{t('Mavzular')}</p>

      {subjectsLoading ? (
        <div className="mt-4 space-y-3">
          {Array.from({ length: 10 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton.Button key={index} active className="!h-10 !w-full" />
          ))}
        </div>
      ) : (
        <div className="mt-2">
          <ul>
            {subjects?.subject?.map(item => {
              const parsedCurrent = parseSubjectName((query?.subject as string) || t('barchasi'))?.toLowerCase();
              const parsedItem = parseSubjectName(item?.name)?.toLowerCase();
              const isActive = parsedCurrent === parsedItem;

              const href = `${globalConst.pageNames.TOPIC_TEST}/${item.name === t('barchasi') ? '' : `${parsedItem}`}`;

              return (
                <li
                  key={item?.id}
                  className="cursor-pointer rounded-md py-2 my-2 pl-4 transition-all"
                  style={{
                    background: isActive ? `${item?.color}1f` : 'transparent',
                    borderRight: `3px solid ${isActive ? item?.color : 'transparent'}`
                  }}
                >
                  <Link href={href} shallow scroll={false} className="flex w-full items-center gap-3">
                    <div className="relative max-h-7 min-h-7 min-w-7 max-w-7">
                      <Image
                        src={item?.image}
                        alt={truncateText({ content: item?.name, length: 10 })}
                        loading="lazy"
                        fill
                        title="Subject list"
                      />
                    </div>
                    <span
                      style={{
                        color: isActive ? item?.color : 'black',
                        fontWeight: isActive ? '500' : '300'
                      }}
                      className='text-sm'
                    >
                      {item.name}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SubjectsList;
